module.exports = __webpack_public_path__ + "images/emerald-designer-edition.fcf0a3a1ba1b36441a2ed1a1f4250c73.png";